import { jsx as t, jsxs as m } from "react/jsx-runtime";
import { useState as h, useEffect as n } from "react";
import { Modal as C } from "../components/Modal.js";
import { InfoIcon as M } from "../../../assets/svgs/InfoIcon.js";
const S = ({
  firstCouponName: d,
  secondCouponName: s,
  setView: u,
  setReplaceCoupon: i,
  setSecondCouponName: c,
  isIO: r,
  closeIOModal: l,
  genericTaggingEvent: o
}) => {
  const [p, a] = h(!0), f = () => {
    a(!1), u("coupons-view");
  }, b = () => {
    o == null || o("discount_coupon", {
      name: "Modal de troca de cupom - botão de substituir cupom",
      cupomName: s
    }), i(!0), u("coupons-view");
  }, e = () => {
    o == null || o("discount_coupon", {
      name: "Modal de troca de cupom - botão de sair"
    }), c(""), u("coupons-view");
  };
  return n(() => {
    p || c("");
  }, [p]), /* @__PURE__ */ t(
    C,
    {
      isIO: r,
      closeModal: r && l ? l : f,
      genericTaggingEvent: o,
      title: "Substituir Cupom",
      confirmButtonAction: b,
      confirmButtonText: "Substituir Cupom",
      cancelButtonAction: e,
      cancelButtonText: "Voltar para Meus Cupons",
      children: /* @__PURE__ */ m("p", { children: [
        /* @__PURE__ */ t("span", { children: /* @__PURE__ */ t(M, {}) }),
        /* @__PURE__ */ m("span", { children: [
          /* @__PURE__ */ t("b", { children: "Não é possível adicionar 2 cupons ao mesmo tempo." }),
          /* @__PURE__ */ t("br", {}),
          'Ao clicar em "Substituir Cupom" você irá substituir o cupom',
          " ",
          /* @__PURE__ */ t("b", { children: d }),
          " pelo cupom ",
          /* @__PURE__ */ t("b", { children: s }),
          "."
        ] })
      ] })
    }
  );
};
export {
  S as OverwriteView
};
